if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.colorHandlers = new Map();
    }

    connectedCallback() {
      this.initializeColorHandlers();
    }

    disconnectedCallback() {
      this.removeColorHandlers();
    }

    initializeColorHandlers() {
      // Handle color selection clicks
      const colorLinks = this.querySelectorAll('.custom-radio > a');
      colorLinks.forEach(link => {
        const handler = this.handleColorClick.bind(this);
        link.addEventListener('click', handler);
        this.colorHandlers.set(link, handler);
      });

      // Handle hover events for color count
      const colorCounts = this.querySelectorAll('.product-colors-count');
      colorCounts.forEach(count => {
        const mouseEnterHandler = this.handleColorCountMouseEnter.bind(this);
        const mouseLeaveHandler = this.handleColorCountMouseLeave.bind(this);
        
        count.addEventListener('mouseenter', mouseEnterHandler);
        count.addEventListener('mouseleave', mouseLeaveHandler);
        
        this.colorHandlers.set(count, { mouseenter: mouseEnterHandler, mouseleave: mouseLeaveHandler });
      });

      // Handle hover events for product colors
      const productColors = this.querySelectorAll('.product-colors');
      productColors.forEach(colors => {
        const mouseLeaveHandler = this.handleProductColorsMouseLeave.bind(this);
        colors.addEventListener('mouseleave', mouseLeaveHandler);
        this.colorHandlers.set(colors, { mouseleave: mouseLeaveHandler });
      });
    }

    removeColorHandlers() {
      this.colorHandlers.forEach((handler, element) => {
        if (typeof handler === 'function') {
          element.removeEventListener('click', handler);
        } else if (typeof handler === 'object') {
          Object.entries(handler).forEach(([event, eventHandler]) => {
            element.removeEventListener(event, eventHandler);
          });
        }
      });
      this.colorHandlers.clear();
    }

    handleColorClick(event) {
      event.preventDefault();
      
      const handle = event.target.dataset.handle;
      const productColors = event.target.closest('.product-colors');
      const productColorway = this.querySelector('.product-colorway-collection');

      if (!productColors || !productColorway) return;

      // Remove active classes
      const activeColorLinks = productColors.querySelectorAll('li a.active');
      const activeColorwayItems = productColorway.querySelectorAll('li.active');
      
      activeColorLinks.forEach(link => link.classList.remove('active'));
      activeColorwayItems.forEach(item => item.classList.remove('active'));

      // Add active classes to selected items
      const selectedColorLink = productColors.querySelector(`[data-handle="${handle}"]`);
      const selectedColorwayItem = productColorway.querySelector(`[data-handle="${handle}"]`);
      
      if (selectedColorLink) selectedColorLink.classList.add('active');
      if (selectedColorwayItem) selectedColorwayItem.classList.add('active');
    }

    handleColorCountMouseEnter(event) {
      if (this.isMobileView()) return;
      
      const colorway = event.target.nextElementSibling;
      if (colorway && colorway.classList.contains('product-colors')) {
        event.target.classList.add('invisible');
        colorway.classList.remove('hidden');
      }
    }

    handleColorCountMouseLeave(event) {
      if (this.isMobileView()) return;
      
      const colorway = event.target.nextElementSibling;
      if (colorway && colorway.classList.contains('product-colors')) {
        colorway.classList.add('hidden');
        event.target.classList.remove('invisible');
      }
    }

    handleProductColorsMouseLeave(event) {
      if (this.isMobileView()) return;
      
      const colorCount = event.target.previousElementSibling;
      if (colorCount && colorCount.classList.contains('product-colors-count')) {
        event.target.classList.add('hidden');
        colorCount.classList.remove('invisible');
      }
    }

    isMobileView() {
      return window.MylesShared && window.MylesShared.isMobileView;
    }
  }

  customElements.define('product-card', ProductCard);
}
